var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  This is the average power that the platform needs. It is\n                  used to compute the available power during the simulation.\n")])}
var staticRenderFns = []
export { render, staticRenderFns }